// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3AYT0","buttons":"SendReceipts_buttons__2MQUg","email":"SendReceipts_email__1PPt5","bookApptTitle":"SendReceipts_bookApptTitle__1VUF4"};